

import Vue from 'vue'
import Vuex from 'vuex'

import state from './state'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'

Vue.use(Vuex)

import moduleAuth from './auth/moduleAuth.js'
import transaction from './transaction/index'
import pulsa from './transaction/pulsa/index'
import zakat from './transaction/zakat/index'
import infak from './transaction/infak/index'
import pln from './transaction/pln/index'
import sedekah from './transaction/sedekah/index'
import paketData from './transaction/paket_data/index'
import campaign from './campaign/index'
import banner from './banner/index'
import news from './news/index'
import ppob from './ppob/index'
import about from './about/index'
import region from './region/index'
import sos from './sos/index'
import mitra from './mitra/index'
import balance from './balance/index'
import paymentGateway from './payment-gateway/index'
import user from './user/index'
import qurban from './transaction/qurban/index'

import createPersistedState from 'vuex-persistedstate'

export default new Vuex.Store({
  getters,
  mutations,
  state,
  actions,
  modules: {
    qurban,
    mitra,
    pln,
    user,
    balance,
    zx_berbagi: sedekah,
    infaq: infak,
    zakat_fitrah: zakat,
    zakat,
    'payment-gateway': paymentGateway,
    pulsa,
    data: paketData,
    sos,
    region,
    about,
    transaction,
    ppob,
    campaign,
    banner,
    news,
    'auth': moduleAuth,
  },
  strict: process.env.NODE_ENV !== 'production',
  plugins: [
    createPersistedState({
      storage: window.sessionStorage
    })
  ]
})
